<template>
  <div
      v-if="item.class !== undefined && item.class.includes('custom')"
      v-bind:class="item.class"
      v-bind:style="item.style"
  >
    <span>
      {{ item.values }}
    </span>
  </div>
  <span
      v-else
      v-bind:class="item.class"
      v-bind:style="item.style"
  >
    {{ item.values }}
  </span>
</template>
<script>
  export default {
      props : ['item'],
  }
</script>